module.exports = __webpack_public_path__ + "img/baby-angel.6e37caf6.svg";